export default __webpack_public_path__ + "static/media/morocco7.3ab7d550.jpg";